import { defineStore } from 'pinia';

export const useCartSidebarStore = defineStore('cartSidebar', {
    state: () => ({
        sidebarOpen: false,
    }),
    actions: {
        invokeCartSidebar() {
            if (!this.sidebarOpen) {
                this.sidebarOpen = true;
                document.body.style.overflow = 'hidden';
            } else {
                this.sidebarOpen = false;
                document.body.style.overflow = '';
            }
        },
    },
});
